import styles from "./Table.module.scss";
import DOMPurify from "dompurify";

const DetailTable = ({ children, elements = [] }) => {
  const useHtmlLabel = ["講座内容"];

  return (
    <table className={styles.detail_table}>
      <tbody>
        {elements.map((elm, i) => {
          return (
            <tr key={i}>
              <th>{elm.label}</th>
              <td>
                {useHtmlLabel.includes(elm.label) ? (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(elm.value, {
                        ALLOWED_TAGS: [],
                      }),
                    }}
                  ></p>
                ) : (
                  <p>{elm.value}</p>
                )}
              </td>
            </tr>
          );
        })}
        {children}
      </tbody>
    </table>
  );
};
export default DetailTable;
